document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.querySelector('[data-sidebar]');
  const open = document.querySelector('[data-sidebar-open]');
  const close = document.querySelector('[data-sidebar-close]');
  const backdrop = document.querySelector('[data-sidebar-backdrop]');

  const openSidebar = () => {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (backdrop) backdrop.hidden = false;
    if (open) open.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeSidebar = () => {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (backdrop) backdrop.hidden = true;
    if (open) open.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  if (open) open.addEventListener('click', openSidebar);
  if (close) close.addEventListener('click', closeSidebar);
  if (backdrop) backdrop.addEventListener('click', closeSidebar);

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeSidebar();
  });

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const jsonNode = root.querySelector('[data-product-json]');
    const variantSelect = root.querySelector('[data-variant-select]');
    const priceNode = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-button]');
    const optionInputs = Array.from(root.querySelectorAll('.ah2-option-buttons input'));

    if (jsonNode && variantSelect) {
      let variants = [];
      try {
        variants = JSON.parse(jsonNode.textContent);
      } catch (e) {
        console.warn('Variant JSON could not be parsed.');
      }

      const syncVariant = () => {
        const selected = optionInputs
          .filter(input => input.checked)
          .map(input => input.value);

        const variant = variants.find(v =>
          selected.every((value, index) => v.options[index] === value)
        );

        const addLabel = addButton?.dataset.addLabel || 'ADD TO CART';

        if (!variant) {
          variantSelect.value = '';
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'UNAVAILABLE';
          }
          return;
        }

        variantSelect.value = String(variant.id);
        const option = variantSelect.querySelector(`option[value="${variant.id}"]`);

        if (priceNode && option) {
          priceNode.textContent = option.dataset.price || '';
        }

        const skuNode = root.querySelector('[data-product-sku]');
        if (skuNode && option) {
          skuNode.textContent = option.dataset.sku || '';
        }

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? addLabel : 'SOLD OUT';
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      optionInputs.forEach(input => input.addEventListener('change', syncVariant));
    }

    const media = Array.from(root.querySelectorAll('[data-media-index]'));
    const mediaButtons = Array.from(root.querySelectorAll('[data-media-button]'));

    mediaButtons.forEach(button => {
      button.addEventListener('click', () => {
        const index = button.dataset.mediaButton;

        media.forEach(item => {
          item.classList.toggle('is-active', item.dataset.mediaIndex === index);
        });

        mediaButtons.forEach(item => {
          item.classList.toggle('is-active', item === button);
        });
      });
    });
  });
});


// Password landing page
document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('[data-password-trigger]');
  const wrap = document.querySelector('[data-password-form-wrap]');
  const cancel = document.querySelector('[data-password-cancel]');
  const input = document.querySelector('[data-password-input]');

  if (!trigger || !wrap) return;

  const showForm = () => {
    trigger.hidden = true;
    wrap.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    window.setTimeout(() => {
      if (input) input.focus();
    }, 30);
  };

  const hideForm = () => {
    wrap.hidden = true;
    trigger.hidden = false;
    trigger.setAttribute('aria-expanded', 'false');
  };

  trigger.addEventListener('click', showForm);

  if (cancel) {
    cancel.addEventListener('click', hideForm);
  }

  // If Shopify returns a password error, show the form immediately.
  if (wrap.querySelector('.ah2-password-error')) {
    showForm();
  }
});


/* =========================================================
   V1.6 — HOMEPAGE WHEEL MENU
   ========================================================= */
(() => {
  const home = document.querySelector('[data-wheel-home]');
  if (!home) return;

  const menu = home.querySelector('.ah-wheel-menu');
  const items = [...home.querySelectorAll('[data-wheel-item]')];
  if (!menu || !items.length) return;

  let active = Math.max(0, items.findIndex(item => item.classList.contains('is-highlighted')));
  let offset = 0;
  let resetTimer;

  const setActive = index => {
    active = (index + items.length) % items.length;
    items.forEach((item, i) => item.classList.toggle('is-highlighted', i === active));
  };

  items.forEach((item, i) => {
    item.addEventListener('mouseenter', () => {
      active = i;
    });
  });

  home.addEventListener('wheel', event => {
    event.preventDefault();

    const direction = event.deltaY > 0 ? 1 : -1;
    setActive(active + direction);

    offset += direction * -14;
    offset = Math.max(-28, Math.min(28, offset));
    menu.style.transform = `translateY(${offset}px)`;

    clearTimeout(resetTimer);
    resetTimer = setTimeout(() => {
      offset = 0;
      menu.style.transform = 'translateY(0)';
    }, 150);
  }, { passive:false });

  home.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setActive(active + 1);
      items[active].focus();
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      setActive(active - 1);
      items[active].focus();
    }
  });
})();


/* =========================================================
   V1.8 — LOOPING VERTICAL REEL + BACKGROUND CROSSFADE
   ========================================================= */
(() => {
  const home = document.querySelector('[data-reel-home]');
  if (!home) return;

  const items = [...home.querySelectorAll('[data-reel-item]')];
  const backgrounds = [...home.querySelectorAll('[data-reel-background]')];
  const prevButton = home.querySelector('[data-reel-prev]');
  const nextButton = home.querySelector('[data-reel-next]');

  if (!items.length) return;

  let activeIndex = 0;
  let locked = false;
  let touchStartY = null;

  const wrap = index => (index + items.length) % items.length;

  const render = () => {
    const prevIndex = wrap(activeIndex - 1);
    const nextIndex = wrap(activeIndex + 1);

    items.forEach((item, index) => {
      item.classList.remove('is-active','is-prev','is-next');

      if (index === activeIndex) item.classList.add('is-active');
      if (index === prevIndex) item.classList.add('is-prev');
      if (index === nextIndex) item.classList.add('is-next');

      item.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
      item.tabIndex = index === activeIndex ? 0 : -1;
    });

    backgrounds.forEach((bg, index) => {
      bg.classList.toggle('is-active', index === activeIndex);
    });
  };

  const move = direction => {
    if (locked) return;
    locked = true;
    activeIndex = wrap(activeIndex + direction);
    render();

    window.setTimeout(() => {
      locked = false;
    }, 390);
  };

  prevButton?.addEventListener('click', () => move(-1));
  nextButton?.addEventListener('click', () => move(1));

  home.addEventListener('wheel', event => {
    event.preventDefault();
    if (Math.abs(event.deltaY) < 8) return;
    move(event.deltaY > 0 ? 1 : -1);
  }, { passive:false });

  home.addEventListener('keydown', event => {
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      move(-1);
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      move(1);
    }
  });

  home.addEventListener('touchstart', event => {
    touchStartY = event.touches[0]?.clientY ?? null;
  }, { passive:true });

  home.addEventListener('touchend', event => {
    if (touchStartY === null) return;
    const endY = event.changedTouches[0]?.clientY ?? touchStartY;
    const distance = endY - touchStartY;

    if (Math.abs(distance) > 35) {
      move(distance < 0 ? 1 : -1);
    }

    touchStartY = null;
  }, { passive:true });

  render();
})();
